module.exports = __webpack_public_path__ + "img/zh.d39d9f5b.jpg";